import { render, staticRenderFns } from "./GraphDetail35.vue?vue&type=template&id=06246642&scoped=true&"
import script from "./GraphDetail35.vue?vue&type=script&lang=js&"
export * from "./GraphDetail35.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06246642",
  null
  
)

export default component.exports